// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import { toast } from "react-hot-toast";
// import {
//   doc,
//   setDoc,
//   serverTimestamp,
//   updateDoc,
//   collection,
//   query,
//   where,
//   getDocs,
//   deleteDoc,
// } from "firebase/firestore";
// import { db, auth } from "../../firebase.config";
// import { createUserWithEmailAndPassword, deleteUser } from "firebase/auth";
// import useAuth from "../../hooks/useAuth";
// import authService from "../../services/auth.service";

// const CheckoutForm = ({ clientSecret, orderId, orderItem, totalAmount }) => {
//   const { user } = useAuth();

//   const navigate = useNavigate();

//   const stripe = useStripe();
//   const elements = useElements();

//   const [guestEmail, setGuestEmail] = useState("");
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [loading, setLoading] = useState(false);

//   const isValidEmailFormat = (email) => {
//     if (!email || typeof email !== "string") return false;

//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

//     return emailRegex.test(email.trim().toLowerCase());
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!user && (!guestEmail || !firstName || !lastName)) {
//       toast.error("Please enter your email address, first name, and last name");
//       return;
//     }
//     if (!isValidEmailFormat(guestEmail)) {
//       toast.error("Please enter a valid email address (e.g. name@example.com)");
//       return;
//     }

//     setLoading(true);

//     // For guest users, we need to verify email doesn't exist BEFORE payment
//     // We do this by attempting to create the account first
//     if (!user) {
//       let createdUser = null;
//       let dummyPassword = null;

//       try {
//         // Step 1: Try to create user account FIRST (before payment)
//         // This will fail if email already exists
//         dummyPassword = `Temp${Date.now()}${Math.random().toString(36).slice(2)}`;
//         const userCredential = await createUserWithEmailAndPassword(
//           auth,
//           guestEmail.trim(),
//           dummyPassword,
//         );
//         createdUser = userCredential.user;
//         console.log("Guest account pre-created with ID:", createdUser.uid);
//       } catch (err) {
//         // If email already exists, show error and stop - NO PAYMENT PROCESSED
//         if (err.code === "auth/email-already-in-use") {
//           toast.error("An account with this email already exists.");
//           setLoading(false);
//           return;
//         }
//         // Other errors during account creation
//         console.error("Error creating guest account:", err);
//         toast.error("Could not create account. Please try again.");
//         setLoading(false);
//         return;
//       }

//       // Step 2: Account created successfully, now process payment
//       toast.loading("Processing payment...", { id: "pay" });

//       if (!stripe || !elements) {
//         // Cleanup: delete the created user since payment can't proceed
//         try {
//           await deleteUser(createdUser);
//         } catch (cleanupErr) {
//           console.error(
//             "Failed to cleanup user after stripe error:",
//             cleanupErr,
//           );
//         }
//         toast.dismiss("pay");
//         toast.error("Stripe not loaded");
//         setLoading(false);
//         return;
//       }

//       const { error, paymentIntent } = await stripe.confirmCardPayment(
//         clientSecret,
//         {
//           payment_method: {
//             card: elements.getElement(CardElement),
//           },
//         },
//       );

//       if (error) {
//         // Payment failed - cleanup the created user
//         try {
//           await deleteUser(createdUser);
//           console.log("Cleaned up user after payment failure");
//         } catch (cleanupErr) {
//           console.error(
//             "Failed to cleanup user after payment failure:",
//             cleanupErr,
//           );
//         }
//         toast.dismiss("pay");
//         console.error("Payment failed:", error);
//         toast.error(error.message || "Payment failed");
//         setLoading(false);
//         return;
//       }

//       if (paymentIntent.status === "succeeded") {
//         toast.dismiss("pay");
//         toast.success("Payment successful!");

//         // Step 3: Payment succeeded, now store the order and user data
//         await handleGuestPostPayment(paymentIntent, createdUser, dummyPassword);
//         setLoading(false);
//       }
//     } else {
//       // Logged-in user flow (unchanged)
//       toast.loading("Processing payment...", { id: "pay" });

//       if (!stripe || !elements) {
//         toast.dismiss("pay");
//         toast.error("Stripe not loaded");
//         setLoading(false);
//         return;
//       }

//       const { error, paymentIntent } = await stripe.confirmCardPayment(
//         clientSecret,
//         {
//           payment_method: {
//             card: elements.getElement(CardElement),
//           },
//         },
//       );

//       if (error) {
//         toast.dismiss("pay");
//         console.error("Payment failed:", error);
//         toast.error(error.message || "Payment failed");
//         setLoading(false);
//       } else if (paymentIntent.status === "succeeded") {
//         toast.dismiss("pay");
//         toast.success("Payment successful!");
//         await storeOrder(paymentIntent);
//         setLoading(false);
//       }
//     }
//   };

//   const handleGuestPostPayment = async (
//     paymentIntent,
//     createdUser,
//     dummyPassword,
//   ) => {
//     const successState = {
//       paymentSuccess: true,
//       paymentIntentId: paymentIntent.id,
//       amount: paymentIntent.amount,
//       currency: paymentIntent.currency,
//       plan: orderItem,
//     };

//     try {
//       const orderData = {
//         userId: createdUser.uid,
//         orderId,
//         name: orderItem?.name || "Plan",
//         amount: orderItem?.price || totalAmount,
//         status: "paid",
//         transactionId: paymentIntent.id,
//         currency: paymentIntent.currency,
//         createdAt: serverTimestamp(),
//         updatedAt: serverTimestamp(),
//       };

//       console.log("Storing order for guest user:", createdUser.uid);

//       await setDoc(doc(db, "orders", String(orderId)), orderData);

//       await setDoc(doc(db, "users", createdUser.uid), {
//         userId: createdUser.uid,
//         email: createdUser.email,
//         firstName: firstName.trim(),
//         lastName: lastName.trim(),
//         subscription_status: true,
//         ...(orderItem?.name && {
//           selectedPlan: orderItem.name,
//           planAssignedAt: serverTimestamp(),
//         }),
//         createdAt: serverTimestamp(),
//       });

//       // Send Setup Link email
//       const setupData = {
//         email: guestEmail,
//         password: dummyPassword,
//         firstName: firstName,
//         lastName: lastName,
//       };

//       await authService.sendSetupEmail(setupData);

//       navigate("/paymentSuccessful", {
//         state: {
//           ...successState,
//           message:
//             "Payment successful! Please check your email to set your password.",
//         },
//       });
//     } catch (err) {
//       console.error("Error during guest account setup:", err);
//       // Payment already succeeded, so we still navigate to success
//       toast.error(
//         "Payment succeeded, but account setup had an issue. Please contact support.",
//       );
//       navigate("/paymentSuccessful", { state: successState });
//     }
//   };

//   const storeOrder = async (paymentIntent) => {
//     try {
//       const orderData = {
//         userId: user.uid,
//         orderId,
//         name: orderItem?.name || "Plan",
//         amount: orderItem?.price || totalAmount,
//         status: "paid",
//         transactionId: paymentIntent.id,
//         currency: paymentIntent.currency,
//         createdAt: serverTimestamp(),
//         updatedAt: serverTimestamp(),
//       };

//       await setDoc(doc(db, "orders", String(orderId)), orderData);

//       await updateDoc(doc(db, "users", user.uid), {
//         subscription_status: true,
//         ...(orderItem?.newPlan && {
//           selectedPlan: orderItem.name,
//           planAssignedAt: serverTimestamp(),
//         }),
//       });

//       navigate("/paymentSuccessful", {
//         state: {
//           paymentSuccess: false,
//           paymentIntentId: paymentIntent.id,
//           amount: paymentIntent.amount,
//           currency: paymentIntent.currency,
//           plan: orderItem,
//         },
//       });
//     } catch (err) {
//       console.error("Error storing order:", err);
//       toast.error("Could not store order");
//     }
//   };

//   return (
//     <div className="h-full overflow-y-auto container mx-auto flex flex-col items-center py-10 px-4">
//       <div className="w-full max-lg:max-w-lg lg:w-2/5 mx-auto">
//         <h1 className="text-3xl text-[#281D1BB2] leading-none text-center font-semibold mb-6">
//           Payment Page
//         </h1>
//         <form onSubmit={handleSubmit} className="space-y-4 flex flex-col">
//           <div className="w-full space-y-4 bg-[#1BB66E1A] border border-[#CFCFCF] shadow-md rounded-lg p-6">
//             {!user && (
//               <>
//                 <div className="mb-4 flex gap-4">
//                   <div className="flex-1">
//                     <label
//                       htmlFor="first-name"
//                       className="block text-sm font-medium text-gray-700 mb-1"
//                     >
//                       First Name
//                     </label>
//                     <input
//                       type="text"
//                       id="first-name"
//                       required
//                       placeholder="Enter your first name"
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                       className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                   <div className="flex-1">
//                     <label
//                       htmlFor="last-name"
//                       className="block text-sm font-medium text-gray-700 mb-1"
//                     >
//                       Last Name
//                     </label>
//                     <input
//                       type="text"
//                       id="last-name"
//                       required
//                       placeholder="Enter your last name"
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                       className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                 </div>
//                 <div className="mb-4">
//                   <label
//                     htmlFor="guest-email"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     id="guest-email"
//                     required
//                     placeholder="Enter your email"
//                     value={guestEmail}
//                     onChange={(e) => setGuestEmail(e.target.value)}
//                     className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>
//               </>
//             )}
//             <CardElement
//               options={{
//                 hidePostalCode: true,
//               }}
//               className="w-full px-3 py-2 mt-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
//           <button
//             type="submit"
//             disabled={!stripe || loading}
//             className="w-fit mt-4 mx-auto bg-[image:--gradient] text-white font-semibold py-2 px-8 rounded-full transition duration-200 disabled:opacity-75"
//             style={{
//               "--gradient":
//                 "linear-gradient(90deg,rgb(4, 4, 4) 0%,rgb(0, 0, 0) 100%)",
//             }}
//           >
//             {loading ? "Paying..." : "Pay Now"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CheckoutForm;

import React from "react";

const CheckoutForm = ({ planName }) => {
  // Replace this with your actual Kajabi Offer Checkout URL
  const KAJABI_CHECKOUT_URL =
    "https://leslie-chen.mykajabi.com/offers/VSLyRktW";

  const handleBuyNow = () => {
    window.location.href = KAJABI_CHECKOUT_URL;
  };

  return (
    <div className="h-full overflow-y-auto container mx-auto flex flex-col items-center py-10 px-4">
      <div className="w-full max-lg:max-w-lg lg:w-2/5 mx-auto">
        <h1 className="text-3xl text-[#281D1BB2] leading-none text-center font-semibold mb-6">
          Complete Your Purchase
        </h1>

        <div className="w-full space-y-4 bg-[#1BB66E1A] border border-[#CFCFCF] shadow-md rounded-lg p-6 text-center">
          {planName && (
            <p className="text-gray-800 text-lg font-medium mb-2">
              Selected Plan: {planName}
            </p>
          )}

          <p className="text-gray-700 text-lg">
            You will be redirected to our secure checkout partner to complete
            your payment.
          </p>

          <button
            onClick={handleBuyNow}
            className="w-fit mt-4 mx-auto bg-[image:--gradient] text-white font-semibold py-3 px-10 rounded-full transition duration-200 hover:opacity-90"
            style={{
              "--gradient":
                "linear-gradient(90deg,rgb(4, 4, 4) 0%,rgb(0, 0, 0) 100%)",
            }}
          >
            Proceed to Checkout
          </button>
        </div>

        <p className="text-center text-gray-500 text-sm mt-4">
          Secure payment powered by Kajabi
        </p>
      </div>
    </div>
  );
};

export default CheckoutForm;

